import React from 'react';
import { CardSurface, Text } from '@spark';

const LoadingTaskData = () => {
    return (
        <div style={{ marginLeft: '10%', marginRight: '10%', marginTop: '20px' }}>
            <CardSurface bordered padding="large">
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Text variant="heading-4-semibold" as="h4">Loading task data...</Text>
                    <div style={{ marginTop: 8 }}>
                        <Text variant="base-regular" color="secondary">
                            If this message persists, please return to the 'Projects' page and select a task.
                        </Text>
                    </div>
                </div>
            </CardSurface>
        </div>
    );
};

export default LoadingTaskData;
